import { combineReducers } from "@reduxjs/toolkit";
import users from "./users";
import projects from "./projects";
import hours from "./hours";
import expenses from "./expenses";
import overview from "./overview";

export default combineReducers({
  users,
  projects,
  hours,
  expenses,
  overview,
});
